import { createElementBlock as t, openBlock as l, createElementVNode as e } from "vue";
import r from "./index289.js";
const n = {}, c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function s(a, o, f, i, p, d) {
  return l(), t("svg", c, o[0] || (o[0] = [
    e("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      e("path", {
        fill: "#E5F2F9",
        d: "M18.648 24.136C13.77 24.802 10 28.94 10 34c0 5.522 4.478 10 10 10h22a8 8 0 0 0 0-16c0-6.628-5.372-12-12-12-5.274 0-9.742 3.406-11.352 8.136Z"
      }),
      e("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "m30 14.75-.317.004a13.242 13.242 0 0 0-11.887 8.107l-.067.165-.115.024C12.501 24.154 8.75 28.664 8.75 34c0 6.212 5.038 11.25 11.25 11.25h22A9.25 9.25 0 0 0 51.25 36l-.004-.268c-.129-4.54-3.53-8.26-7.926-8.889l-.122-.015-.004-.05C42.577 20.031 36.906 14.75 30 14.75Zm0 2.5c5.938 0 10.75 4.812 10.75 10.75 0 .69.56 1.25 1.25 1.25a6.75 6.75 0 0 1 0 13.5H20A8.751 8.751 0 0 1 11.25 34c0-4.374 3.247-8.036 7.567-8.625a1.25 1.25 0 0 0 1.014-.836A10.744 10.744 0 0 1 30 17.25Z"
      })
    ], -1)
  ]));
}
const u = /* @__PURE__ */ r(n, [["render", s]]);
export {
  u as default
};
